import React from 'react'
import styled from 'styled-components'
import { Button as MButton, CircularProgress } from '@material-ui/core'

const StyledButton = styled(MButton)`
  &.Mui-disabled {
    background: #132335 !important;
    opacity: 0.6 !important;
    color: #fafafa !important;
  }
`

function Button({ label, onClick, color = "primary", startIcon, endIcon, disabled, loading = false }) {
  return (

    <StyledButton
      onClick={!loading ? onClick : undefined}
      color={color}
      variant="contained"
      startIcon={loading ? <CircularProgress size={20} style={{ color: '#fafafa' }} /> : startIcon}
      endIcon={!loading ? endIcon : undefined}
      disabled={disabled || loading}
      style={{
        height: 45
      }}
    >
      {label}
    </StyledButton>
  )
}

export default Button